import React from 'react'
import '../../App.css'
import BuildPage from '../BuildPage';

export default function Build()
{
    return (        <>
        <BuildPage />
        </>)

}